module.exports = __webpack_public_path__ + "88722c58bae3bec9f520463da9657a6c.svg";